(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instagram-feed"] && !Shopify.designMode) return;
  try {
    
$(document).on('shopify:section:load',function(){
setTimeout(function(){
      $('.Instafeed').find('.flickity-slider').find('a').each(function(index){
        var clone = $(this).clone();
        if(index == 1){
          $('.insta_custom_ul_first').append(clone)
        }else{
          $('.insta_custom_ul_second').append(clone)
        }
      });
    },1000);
});

  } catch(e) { console.error(e); }
})();
})();
